// extracted by mini-css-extract-plugin
module.exports = {"heading":"lJGIJ","h1-category":"_36QAA","h1Category":"_36QAA","h1":"_1ekr7","h2":"_22tJn","h3":"qYbGf","h4":"_2wY3M","h5":"-k_6Q","link":"_3T4pg","light":"_37PIY"};